import { render, staticRenderFns } from "./IDENTIFY_CONTENT.vue?vue&type=template&id=7084a9ac"
import script from "./IDENTIFY_CONTENT.vue?vue&type=script&lang=js"
export * from "./IDENTIFY_CONTENT.vue?vue&type=script&lang=js"
import style0 from "./IDENTIFY_CONTENT.vue?vue&type=style&index=0&id=7084a9ac&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports